import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class RegioneComunaliB extends Component {
  render() {
    let { regione} = this.props.params;
    let repoDettaglio = "/elezioni/withub/electionday-2024/comunali-ballottaggio/" + regione + "/" + regione + ".html";
    let repoFascione = "/elezioni/withub/electionday-2024/comunali-ballottaggio/fascione-osservati.html";
    return (
    <div className="App">
        <EWH id="ewh-dettaglio" repo={repoDettaglio} />
        <EWH id="ewh-fascione" repo={repoFascione} />
    </div>
    )
  }
}

export default withParams(RegioneComunaliB)
